const actionBase = 'DASHBOARD_OCCUPANCY_RATE'
const STATE = {
  occupancy_rate: null,
  errMsg: null,
  sucMsg: null,
  loading: false,
}

export function occupancyRate(action){

  switch (action.type) {

    // On Pending
    case `${actionBase}_LOAD_REQUEST`:
      return {...STATE, loading: true}

    // On success request
    case `${actionBase}_LOAD_SUCCESS`:
      return {
        ...STATE,
        occupancy_rate: action.payload.occupancy_rate,
        loading: false
      }

    // On failed request
    case `${actionBase}_LOAD_FAILURE`:
      return {
        ...STATE,
        errMsg: action.payload,
        loading: false
      }

    default:
      return STATE

  }

}
